import { keepEditorFocusOnMouseDown as e } from "./keep-editor-focus.mjs";
import { twMerge as t } from "tailwind-merge";
import { Button as n, PassiveTooltip as r } from "@systemeio/components";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/content-controls/toolbar-button.tsx
function a({ active: a, children: o, className: s, disabled: c, label: l, labelledByContent: u = !1, onMouseDown: d, size: f = "icon-sm", tooltip: p = l, ...m }) {
	let h = {
		"aria-label": u ? void 0 : l,
		"aria-pressed": a,
		className: t("aria-pressed:border-button-ghost-gray-pressed aria-pressed:bg-button-ghost-gray-pressed", s),
		disabled: c,
		onMouseDown: e(d),
		size: f,
		variant: "ghost-gray",
		...m
	};
	return !p || c ? /* @__PURE__ */ i(n, {
		...h,
		children: o
	}) : /* @__PURE__ */ i(r, {
		content: p,
		showArrow: !1,
		trigger: o,
		triggerProps: { render: /* @__PURE__ */ i(n, { ...h }) }
	});
}
//#endregion
export { a as ToolbarButton };
